// dashboard/modals/AssignModal.js
// Workflow assignment modal. Extracted from App.js (2026-08-12 split).

import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { c } from '../constants';
import { useModalA11y } from '../useModalA11y';

export default function AssignModal({ pet, workflows, vets, onAssign, onCancel, loading, error }) {
  const { t } = useTranslation();
  const [wf,  setWf]  = useState('');
  const [vet, setVet] = useState(vets[0]?.id || '');
  const isWellnessOnly = wf === '__wellness_only__';
  const ok = wf && (isWellnessOnly || vet);
  const containerRef = useModalA11y(onCancel);

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(79,100,115,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}>
      <div
        ref={containerRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="assign-modal-title"
        style={{ backgroundColor: c.white, borderRadius: 16, padding: 28, width: '100%', maxWidth: 440, boxShadow: '0 8px 32px rgba(79,100,115,0.18)', outline: 'none' }}
      >
        <h2 id="assign-modal-title" style={{ fontSize: 17, fontWeight: 600, color: c.slate, marginBottom: 4 }}>{t('assignWorkflow.title')}</h2>
        <p style={{ fontSize: 12, color: c.textSoft, marginBottom: 20 }}>{pet.name} — {pet.profiles?.first_name} {pet.profiles?.last_name}</p>

        <label htmlFor="assign-workflow" style={{ display: 'block', fontSize: 12, fontWeight: 500, color: c.slate, marginBottom: 6 }}>{t('assignWorkflow.workflowLabel')}</label>
        <select id="assign-workflow" style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${c.border}`, backgroundColor: c.fog, fontSize: 13, marginBottom: 14 }} value={wf} onChange={e => setWf(e.target.value)}>
          <option value="">{t('assignWorkflow.selectWorkflow')}</option>
          <option value="__wellness_only__">{t('assignWorkflow.wellnessOnly')}</option>
          {workflows.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
        </select>

        {/* No disease workflow is created for wellness-only linking, so
            there's no "assigned clinician" to record — this pet isn't
            being monitored for anything a doctor needs attributed to
            them. See handleAcceptWellnessOnly, migration 104. */}
        {!isWellnessOnly && (
          <>
            <label htmlFor="assign-clinician" style={{ display: 'block', fontSize: 12, fontWeight: 500, color: c.slate, marginBottom: 6 }}>{t('assignWorkflow.clinicianLabel')}</label>
            <select id="assign-clinician" style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${c.border}`, backgroundColor: c.fog, fontSize: 13, marginBottom: 20 }} value={vet} onChange={e => setVet(e.target.value)}>
              {vets.map(v => <option key={v.id} value={v.id}>{t('patientDetail.doctorPrefix', { firstName: v.first_name, lastName: v.last_name })}</option>)}
            </select>
          </>
        )}
        {isWellnessOnly && (
          <p style={{ fontSize: 12, color: c.textSoft, marginBottom: 20 }}>{t('assignWorkflow.wellnessOnlyHint')}</p>
        )}

        {error && <p role="alert" style={{ fontSize: 12, color: c.error, marginBottom: 12 }}>{error}</p>}

        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onCancel} style={{ padding: '8px 16px', background: 'none', border: `1px solid ${c.border}`, borderRadius: 8, fontSize: 13, cursor: 'pointer', color: c.textSoft }}>{t('common.cancel')}</button>
          <button onClick={() => ok && onAssign(wf, vet)} disabled={!ok || loading} style={{ padding: '8px 16px', backgroundColor: c.moss, color: c.white, border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: ok ? 'pointer' : 'not-allowed', opacity: ok ? 1 : 0.5 }}>
            {loading ? t('assignWorkflow.assigning') : t('assignWorkflow.assignButton')}
          </button>
        </div>
      </div>
    </div>
  );
}
